import logo from "./logo.svg";
import react, { Suspense } from "react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { AuthContextProvider } from "./context/auth/ApiContext";
import { MembershipContextProvider } from "./context/membership/membership";
import { SettingContextProvider } from "./context/Setting/Setting";
import { Backdrop, CircularProgress } from "@mui/material";


//Pages
import Home from "./pages/student/home";
import CourseDsahboard from "./pages/student/course";
import Welcome from "./pages/welcome/Welcome"
import Login from "./pages/auth/login";
import Register from "./pages/auth/register";
import Reset from "./pages/auth/resetpassword";
import Membership from "./pages/student/membership";
import Profile from "./pages/student/profile";
import CoursesDashboard from "./pages/student/courses";
import CalendarDashboard from "./pages/student/calendar";
import CourseInfo from "./pages/course";
import Inbox from "./pages/student/inbox/inbox";
import Certificate from "./pages/certificate";
import SetPassword from "./pages/auth/setpassword";
import InstructorDetail from "./pages/instructor";
import Logout from "./pages/logout";
import Acknowledgement from "./pages/acknowledgement";
import WelcomeCourses from "./pages/courses";
import Testimonial from "./pages/testimonial";
import Help from "./pages/help";

// const Home = lazy(() => import());
// const Courses=lazy(()=> import("./pages/secured/courses/Courses"));
// const CourseDsahboard = lazy(() => import("./pages/student/course"));
// const Welcome = lazy(() => import("./pages/welcome/Welcome"));
// const Login = lazy(() => import("./pages/auth/login"));
// const Register = lazy(() => import("./pages/auth/register"));
// const Reset = lazy(() => import("./pages/auth/resetpassword"));
// const Membership = lazy(() => import("./pages/student/membership"));
// const Profile = lazy(() => import("./pages/student/profile"));
// const CoursesDashboard = lazy(() => import("./pages/student/courses"));
// const CalendarDashboard = lazy(() => import("./pages/student/calendar"));

// const CourseInfo = lazy(() => import("./pages/course"));


function App() {
  return (
    <Router>
      <Switch>
        <AuthContextProvider>
          <MembershipContextProvider>
            <SettingContextProvider>
              <Route name="dashboard" path="/student/home" exact={true}>
                <Home />
              </Route>
              <Route name="course-section" path="/student/course/:course" exact={true}>
                <CourseDsahboard />
              </Route>
              <Route name="courses-list" path="/student/courses" exact={true}>
                <CoursesDashboard />
              </Route>
              <Route name="profile" path="/student/profile" exact={true}>
                <Profile />
              </Route>
              <Route name="inbox" path="/student/inbox" exact={true}>
                <Inbox />
              </Route>
              <Route name="calendar" path="/student/calendar" exact={true}>
                <CalendarDashboard />
              </Route>
              <Route name="membership" path="/student/membership" exact={true}>
                <Membership />
              </Route>
              <Route name="certificate-confirm" path="/certificate/verify" exact={true}>
                <Certificate />
              </Route>
              <Route name="course-info" path="/course/:course" exact={true}>
                <CourseInfo />
              </Route>
              <Route name="instructor-info" path="/instructor/detail/:id" exact={true}>
                <InstructorDetail />
              </Route>
              <Route name="acknowledgement" path="/acknowledgement" exact={true}>
                <Acknowledgement />
              </Route>
              <Route name="testimonial" path="/testimonial" exact={true}>
                <Testimonial />
              </Route>
              <Route name="courses" path="/courses" exact={true}>
                <WelcomeCourses />
              </Route>
              <Route name="help" path="/help" exact={true}>
                <Help />
              </Route>
              <Route name="login" path="/auth/login" exact={true}>
                <Login />
              </Route>
              <Route name="logout" path="/auth/logout" exact={true}>
                <Logout />
              </Route>
              <Route name="register" path="/auth/register" exact={true}>
                <Register />
              </Route>
              <Route name="reset" path="/auth/resetpassword" exact={true}>
                <Reset />
              </Route>
              <Route name="set-password" path="/auth/setpassword" exact={true}>
                <SetPassword />
              </Route>
              <Route name="welcome" path="/" exact={true}>
                <Welcome />
              </Route>
            </SettingContextProvider>
          </MembershipContextProvider>
        </AuthContextProvider>
        {/* <Route name="courses" path="/courses" exact={true}>
          <Courses />
        </Route>
        <Route name="course" path="/courses/:id" exact={true}>
          <Course />
        </Route> */}


      </Switch>
      {/* </Suspense> */}
    </Router>
  );
}

export default App;
